import { render } from "./PlanoDeFundo.vue?vue&type=template&id=6e95cca8"
import script from "./PlanoDeFundo.vue?vue&type=script&lang=js"
export * from "./PlanoDeFundo.vue?vue&type=script&lang=js"

import "./PlanoDeFundo.vue?vue&type=style&index=0&id=6e95cca8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__